/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ file_size: NonNullable<unknown>, image_size: NonNullable<unknown> }} Chat_Attachment_SizeInputs */



/**
* | output |
* | --- |
* | "That file is too big. A file can be up to {file_size}, an image up to {image_size}." |
*
* @param {Chat_Attachment_SizeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_attachment_size = /** @type {((inputs: Chat_Attachment_SizeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attachment_SizeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Dat bestand is te groot. Een bestand mag tot ${i?.file_size} groot zijn, een afbeelding tot ${i?.image_size}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ce fichier est trop volumineux. Un fichier peut faire jusqu'à ${i?.file_size}, une image jusqu'à ${i?.image_size}.`)
	return /** @type {LocalizedString} */ (`That file is too big. A file can be up to ${i?.file_size}, an image up to ${i?.image_size}.`)
});